import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import util from 'Utils/commonUtil';
import { 
	fOneOrderQuery, 
	getMoreOrders,
	updateAdminF1OrderTabActive, 
	updateAdminF1OrderSearchFields, 
	updateAdminF1OrderDetail
} from 'Actions/replenishment';
import Anchor from 'Components/common/Anchor';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import F1OrderCard from 'Components/replenishment/F1OrderCard';
import LoadingIcon from 'Components/icons/LoadingIcon';
import { setOrderData } from 'Actions/localData';
import { T } from 'Actions/translate';

class AdminF1OrderList extends Component {

    state = {
        tabList: [
            { index: 0, text: T('user_center_not_receive'), tabFlg: 1 },
            { index: 1, text: T('off_the_stocks'), tabFlg: 2 }
        ],
        // tabActive: 0,
        pageLoad: true,
	}

    searchRequestTimer = null;

    componentDidMount() {
		this.getOrders()
    }

 	handleChange = (name, value) => {
		this.setState({ [name]: value });
  	}

	handleSearch = (title, value) => {
		let searchParam = {
    		'queryKey': value
		}

		this.getOrders(searchParam)
		this.props.updateAdminF1OrderSearchFields({
			[title]: { $set: value }
		});
	}

  	handleChangeTab = (item) => {
		this.props.updateAdminF1OrderTabActive({$set: item.index});
		this.getOrders({'tabFlag': item.tabFlg });
  	}

  	hideloading = () => {
        this.setState({
        	pageLoad: false
        });
  	}

    goToSCDetails = () => {
      this.props.history.push('/replenishmentSCDetails');
    }

    getMore = () => {
  		const { f1OrderList } = this.props;

  		this.props.getMoreOrders({
  			'pageSize': 10,
  		 	'tabFlag': this.state.tabList[this.props.tabActive].tabFlg,
  		 	'queryKey': this.props.queryKey.trim(),
  		 	'pageNum': f1OrderList && f1OrderList.pageNum ? f1OrderList.pageNum + 1 : 1
  		})
    }

    getOrders = (params) => {
    	this.setState({
        	pageLoad: true
        });

      window.clearTimeout(this.searchRequestTimer);

      this.searchRequestTimer = setTimeout(() => {
      	this.props.fOneOrderQuery({
  			'tabFlag': this.state.tabList[this.props.tabActive].tabFlg,
      		'pageNum': params && params.pageNum ? params.pageNum : 1,
      		'pageSize': params && params.pageSize ? params.pageSize : 10,
      		'queryKey':  params && params.queryKey ? params.queryKey : this.props.queryKey
      	}, this.hideloading);
      }, 500);
    }

    chooseOrder = (orderDetails) => {
	  this.props.updateAdminF1OrderDetail({$set: {}})
      this.props.setOrderData(orderDetails);

      if (this.props.tabActive === 0) {
        this.props.history.push('/ShippedF1OrderDetails');
      } else {
        this.props.history.push('/AdminF1OrderDetails');
      }
    }
    goBack = () => this.props.history.push('/userCenter');

    render() {
      	const { tabList, pageLoad } = this.state;
	    const { f1OrderList, replenishmentListLoaded, listLoaded, tabActive, queryKey } = this.props;

      	return (
	      	<div className='admin-f1-order-list'>

	      		<Header hasUserCenter={ true } hasArrowBackIos={ true } backEvent={ this.goBack }>

			      	<Grid className='page-title-container no-margin' container spacing={0} justify={'space-evenly'}>
			        	<Grid className='page-title' item xs={11}>
			            	<span>{T('header_fone_order')}</span>
			        	</Grid>
			      	</Grid>

			      	<Grid className='page-search-container no-margin' container spacing={0} justify={'space-evenly'}>
			        	<Grid  item xs={11}>
                        	<SearchInput title="queryKey" value={ queryKey } onChange={ this.handleSearch } options={{ hideSearchBtn: true }} placeholder={ T('enter_scNo_scName_orderNo_EoneNo') }></SearchInput>
			      		</Grid>
			      	</Grid>

                    <div className="tab-header">
                        {
                            tabList.map((item, index) => {
                                return (
                                    <a key={ item.index } id={'tab' + item.index} className={ util.getClassName({ 'tab-item': true, active: index === tabActive }) } onClick={ () => { this.handleChangeTab(item) } }>{ item.text }</a>
                                );
                            })
                        }
                    </div>

	      		</Header>

            { pageLoad ? <LoadingIcon className="circle-animation"/> :
                            <ScrollWrapper showLoadingMore={replenishmentListLoaded} showAbyss={f1OrderList.pageNum >= f1OrderList.pageTotal } getMoreData={this.getMore} listLoaded={listLoaded}>
	    				      			    <Grid className='note-container no-margin' container spacing={0} justify={'space-evenly'}>
	      					      			    <Grid item xs={11}>
	        				                    	{ f1OrderList.data && f1OrderList.data.map((item) =>
	        				                    		  <F1OrderCard key={item.id}
	        				                    		  			   orderDetails={item}
	        				                    		  			   chooseOrder={this.chooseOrder}
	        				                    		  			   type={tabActive}/>
	        				                    	)}
	      				                    	</Grid>
	    				            	    </Grid>
                            </ScrollWrapper>
            }

	      	</div>
      );
    }

}

const mapStateToProps = state => {
  	const { replenishment } = state;
  	return {
  		f1OrderList: replenishment.f1OrderList,
 		replenishmentListLoaded: replenishment.replenishmentLoadingMore,
        listLoaded: replenishment.replenishmentListLoaded,
        tabActive: replenishment.tabActive,
        queryKey: replenishment.searchfields.queryKey
  	};
};

const mapDispatchToProps = {
  	fOneOrderQuery,
  	getMoreOrders,
	setOrderData,
	updateAdminF1OrderTabActive,
	updateAdminF1OrderSearchFields, 
	updateAdminF1OrderDetail 
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminF1OrderList);
